import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


import Logo from '../../../images/logo_nutriportal2024.png';

import {
  Avatar,
  Button as Btn,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider
} from '@mui/material';

import {
  Typography
} from '../../../components/v2/styled';
import { CardBase } from './Base';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';

import HelpersLanguage from '../../../actions/helpers/language';

type Props = {
  course: KnowledgeCourse;
  hideHeader?: boolean;
  hideOpen?: boolean;
  coach?: boolean;
  onboarding?: boolean;
  sx?: any;
};

export const CardCourse: FunctionComponent<Props> = ({course, sx, hideHeader, hideOpen, coach, onboarding}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  return (<CardBase sx={{...sx}}>
    {!hideHeader && !!course.knowsub?.id && !course.knowsub.lesson_data?.course_complete && <CardHeader
      disableTypography
      sx={{backgroundColor: theme.palette.primary.main, paddingTop: 1, paddingBottom: 1, zIndex: 1202}}
      title={<Typography variant="subtitle1" sx={{
        textAlign: 'center',
        color: theme.palette.primary.contrastText,
      }}>{t("client.course_card.headers.subscribed")}</Typography>}
    />}
    {!hideHeader && !!course.knowsub?.id && !!course.knowsub.lesson_data?.course_complete && <CardHeader
      disableTypography
      sx={{backgroundColor: theme.palette.primary.main, paddingTop: 1, paddingBottom: 1, zIndex: 1202}}
      title={<Typography variant="subtitle1" sx={{
        textAlign: 'center',
        color: theme.palette.primary.contrastText,
      }}>{t("client.course_card.headers.completed")}</Typography>}
    />}
    <CardMedia
      sx={{
        height: !hideHeader && !!course.knowsub?.id ? 56 : 100,
        backgroundPositionY: '40%',
        backgroundColor: (!!course.is_bg_color ? (!!(course.extra_data || {}).background_colour ? (course.extra_data || {}).background_colour : 'rgba(0, 0, 0, 0.2)') : 'transparent')
      }}
      image={!course.is_bg_color ? course.get_item : undefined}
      title={(course.full_name || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')]}
    />
    <CardContent style={{marginTop: '-100px', marginBottom: 'auto'}}>
      <Avatar sx={{
        width: 100,
        height: 100,
        zIndex: 1200,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        backgroundColor: 'white',
        "& img": {
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto'
        }
      }} src={(!!course.is_nutri || !!course.is_it) ? Logo : course.practice?.get_item} />

      {!!course.is_nutri && <Typography sx={{color: theme.palette.tertiary?.main, marginTop: 1}}>{t("general.terms.nutriportal")}</Typography>}
      {!!course.is_it && <Typography sx={{color: theme.palette.tertiary?.main, marginTop: 1}}>{t("general.terms.it_team")}</Typography>}
      {!course.is_nutri && !course.is_it && <Typography sx={{color: theme.palette.tertiary?.main, marginTop: 1}}>{course.practice?.name}</Typography>}
      <Typography sx={{fontSize: '1.1rem'}}>{(course.full_name || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')]}</Typography>

      <Divider sx={{marginTop: 1, marginBottom: 1}} />

      <Typography>{(course.full_teaser || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')]}</Typography>
    </CardContent>
    {!hideOpen && <CardActions>
      {!!course.knowsub?.id && !!course.knowsub?.is_approved && <Btn
        onClick={() => {
          navigate(`/knowledge_subscription/${course.knowsub?.lesson_key}`);
        }}
      >{t("coach.submenu.agenda.appointments.open")}</Btn>}
      <Btn
        onClick={() => {
          navigate(!!onboarding ? `/knowledge/${course.id}` : (!!coach ? `/course/${course.id}` : `/knowledge_course/${course.id}`));
        }}
      >{t("coach.submenu.agenda.appointments.detail")}</Btn>
    </CardActions>}
  </CardBase>);
}